export class DocumentFile {
    id: number;
    fileDescriptorId: string;
    description: string;
    hashFile: string;
    uploadId: number;
    creationDate: Date;
}